import { createStateHook, type HookStateFunction } from 'react-sweet-state';

import type { ChatStorePrivateState } from '@atlassian/conversation-assistant-store/controllers/chat/types';

import { chatStore } from './chatStore';

export const usePromptHistoryState: HookStateFunction<
	ChatStorePrivateState['promptHistory'],
	void
> = createStateHook(chatStore, {
	selector: (state: ChatStorePrivateState) => state.promptHistory,
});
